import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TableModule } from "primeng/table";
import { FormsModule } from "@angular/forms";
import { ModalModule } from "ngx-bootstrap";
import { VisibleColumnsPipe } from "./visible-columns.pipe";
import { PaginationARModule } from "../../../pagination/pagination-ar.module";
import { SearchContentComponent } from "./search-content.component";
import { SearchModalService } from "./search-modal.service";

@NgModule({
  imports: [
    CommonModule,
    TableModule,
    FormsModule,
    ModalModule.forRoot(),
    PaginationARModule
  ],
  declarations: [SearchContentComponent, VisibleColumnsPipe],
  exports: [SearchContentComponent, VisibleColumnsPipe],
  entryComponents: [SearchContentComponent],
  providers: [SearchModalService]
})
export class SearchContentModule {}
